import { combineReducers } from '@reduxjs/toolkit';
import app from './appSlice';
import nav from './navSlice';
import browser, { initialState as browserInitialState } from './browserSlice';
import camera, { initialState as cameraInitialState } from './cameraSlice';
import microphone, { initialState as microphoneInitialState } from './microphoneSlice';
import speakers, { initialState as speakersInitialState } from './speakersSlice';
import connectivity, { initialState as connectivityInitialState } from './connectivitySlice';

export const checksInitialState = {
  browser: browserInitialState,
  camera: cameraInitialState,
  microphone: microphoneInitialState,
  speakers: speakersInitialState,
  connectivity: connectivityInitialState,
};

export const createReducers = ({ checkList }) => {
  const checkReducerMap = {
    browser,
    camera,
    microphone,
    speakers,
    connectivity,
  };
  Object.keys(checkReducerMap).forEach((checkLabel) => {
    if (!checkList.includes(checkLabel)) {
      delete checkReducerMap[checkLabel];
    }
  });
  const checks = combineReducers(checkReducerMap);
  return {
    app,
    nav,
    checks,
  };
};
